import { Component } from 'react'

import * as h from 'h'

import styles from './styles-menu.scss'

export default class Menu extends Component {
  // --------------------------------------------------------------------------
  // Lifecycle
  // --------------------------------------------------------------------------

  shouldComponentUpdate () {
    return false
  }

  // --------------------------------------------------------------------------
  // Render
  // --------------------------------------------------------------------------

  render () {
    const { menu, onClick } = this.props

    const items = menu
      .map(({ slug, name, url }) => (
        url
        ? h.l({ to: url, key: slug, ...h.ca(styles.item, styles.link) }, name)
        : h.z({ key: slug, onClick: () => onClick(slug), ...h.ca(styles.item) }, name))
      )

    return h.div(h.ca(styles.menu), items)
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/containers/Landing/Menu.js